/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import Dialog from "@react/react-spectrum/Dialog";
import PropTypes from "prop-types";

function InvalidValueDialog(props) {
  const formatMessage = props.intl.formatMessage;
  return (
    <Dialog
      title={formatMessage({
        id: props.label
      })}
      variant="error"
      onConfirm={props.cancelDialog}
      confirmLabel={formatMessage({ id: props.confirmLabel })}
      autoFocusButton="confirm"
    >
      <span>{props.errorMessage}</span>
    </Dialog>
  );
}

export default InvalidValueDialog;
InvalidValueDialog.defaultProps = {
  errorMessage: ""
};

InvalidValueDialog.propTypes = {
  intl: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.func])).isRequired,
  cancelDialog: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  confirmLabel: PropTypes.string.isRequired
};
